GroupMemberService = ($http ,$q )  ->

  listMemRequest:(dParam) ->
    defer = $q.defer()
    url = "/api/groups/#{dParam.id}/list_request.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  processMemRequest:(dParam) ->
    url = "/api/group_entries/#{dParam.id}.json"
    $http.put(url ,dParam )

  listMembers:(dParam) ->
    defer = $q.defer()
    url = "/api/groups/#{dParam.id}/members.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  changeMembers:(dParam) ->
    url = "/api/groups/#{dParam.id}/update_group_entries.json"
    $http.post url , dParam

GroupMemberService.$inject = [
  '$http'
  '$q'
]

module.exports = GroupMemberService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/group-member-service.coffee